<template>
  <div class="main">
    <el-dialog
      :title="openData.title"
      :visible.sync="openData.state"
      :close-on-click-modal="false"
      width="70%"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="dialog_content">
        <el-form
          :disabled="openData.title == '详情'"
          label-position="left"
          label-width="150px"
          ref="formData"
          :model="formData"
          :rules="formDataRules"
        >
          <el-form-item label="学校：" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="11">
              <el-form-item label="图片：" prop="photo" align="left">
                <el-upload
                  :action="baseUrl"
                  :show-file-list="false"
                  :on-success="
                    (file, fileList) => {
                      handleAvatarSuccess(file, fileList, 'add')
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <div>
                    <div class="avatar" v-if="formData.photo != ''">
                      <img
                        :src="
                          formData.photo == '../../assets/img/user.png'
                            ? ''
                            : formData.photo
                        "
                      />
                    </div>
                    <i
                      v-else
                      class="el-icon-plus avatar_uploader avatar-uploader-icon"
                    ></i>
                  </div>
                </el-upload>
              </el-form-item>

              <el-form-item label="地址：" prop="location">
                <el-input
                  v-model="formData.location"
                  :autosize="{ minRows: 2 }"
                  type="textarea"
                  placeholder="请输入地址"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="11" :offset="1">
              <el-form-item label="封面上传：" prop="photo" align="left">
                <el-upload
                  :action="baseUrl"
                  :show-file-list="false"
                  :on-success="
                    (file, fileList) => {
                      handleAvatarSuccess1(file, fileList, 'add')
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <div>
                    <div class="avatar" v-if="formData.cover != ''">
                      <img
                        :src="
                          formData.cover == '../../assets/img/user.png'
                            ? ''
                            : formData.cover
                        "
                      />
                    </div>
                    <i
                      v-else
                      class="el-icon-plus avatar_uploader avatar-uploader-icon"
                    ></i>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input
                  v-model="formData.remark"
                  :autosize="{ minRows: 2 }"
                  type="textarea"
                  placeholder="请输入备注"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="资源GIS定位：">
            <el-button
              type="success"
              class="button"
              size="mini"
              @click="showMap"
              style="margin-bottom: 25px"
              >地图定位</el-button
            >
            <div v-show="isMaps == true">
              <el-row>
                <el-col :span="4">
                  <el-form-item>
                    <el-select
                      v-model="formData.provinceId"
                      placeholder="请选择省"
                      @change="handleProvince"
                      :disabled="
                        normalInfo.orgLevel == 1 ||
                        normalInfo.orgLevel == 2 ||
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5 ||
                        openData.title == '详情'
                      "
                      style="width: 100%"
                      ref="selectShengChange"
                    >
                      <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.cityId"
                    placeholder="请选择市"
                    :disabled="
                      normalInfo.orgLevel == 2 ||
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '详情'
                    "
                    @change="handleCity"
                    ref="selectShiChange"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.zoneId"
                    placeholder="请选择区"
                    @change="handleArea"
                    :disabled="
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '详情'
                    "
                    ref="selectQuChange"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.streetId"
                    placeholder="请选择街道"
                    :disabled="
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '详情'
                    "
                    @change="streetChange"
                    ref="selectJiedaoChange"
                  >
                    <el-option
                      v-for="(item, index) in streetList"
                      :key="index"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.shequId"
                    placeholder="请选择社区"
                    :disabled="
                      normalInfo.orgLevel == 5 || openData.title == '详情'
                    "
                    ref="selectShequChange"
                    @change="handleCommunityChange"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.id"
                      :label="item.address"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <input
                v-model.trim="formData.address"
                :disabled="openData.title == '详情'"
                id="tipinput"
                class="el-input__inner"
                :class="openData.title == '详情' ? 'innerCur' : ''"
                @focus="getMap('tipinput')"
                placeholder="请输入关键字"
                autocomplete="off"
              />
              <div class="map_container">
                <div
                  class="map_right"
                  id="container"
                  style="width: 100%; height: 300px"
                ></div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer dialog-footer-btn"
        v-if="openData.title != '详情'"
      >
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialogVisibleClone">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseURL from "@/api/baseURL"
export default {
  props: ["openData"],
  data() {
    var chekPhone = (rule, value, callback) => {
      let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (!validatePhone.test(value)) {
        return callback(new Error("手机号格式错误"))
      }
      callback()
    }
    return {
      baseURL: "",
      imageUrl: "",
      formData: {
        id: "",
        name: "",
        phone: "",
        provinceId: "", //省
        cityId: "", //市
        zoneId: "", //区
        streetId: "", //街道
        shequId: "", //社区
        belongSocialOrgId: "", //组织id
        address: "",
        photo: "",
        longitude: "",
        auditFlag: "1",
        latitude: "",
        provinceName: "",
        cover: "",
        city: "",
        zone: "",
        street: "",
        shequ: "",
      },
      orgList: [],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      marker: null, //地图标记点
      recMap: null,
      recIsMap: true,
      recPolygons: [],
      recPolygon: [],
      recMarker: null, //地图标记点
      formDataRules: {
        //表格表单验证
        name: [
          {
            required: true,
            message: "请输入学校名称",
            trigger: "blur",
          },
        ],
        score: [
          {
            required: true,
            message: "站点名称不能为空",
            trigger: "blur",
          },
        ],
        recruitType: [
          {
            required: true,
            message: "机构类型不能为空",
            trigger: "blur",
          },
        ],

        phone: [
          //手机
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],

        applicantsLimit: [
          {
            required: true,
            message: "区域名称不能为空",
            trigger: "blur",
          },
        ],
      },
      isMaps: false,
      normalInfo: {},
    }
  },
  created() {
    this.baseUrl = baseURL + "/ypt/controller/uploadController/info/uploadPhoto"

    this.formData = {
      id: "",
      name: "",
      provinceId: "", //省
      cityId: "", //市
      zoneId: "", //区
      streetId: "", //街道
      shequId: "", //社区
      belongSocialOrgId: "", //组织id
      address: "",
      cover: "",
      source: [],
      photo: "",
      longitude: "",
      latitude: "",
      auditFlag: "1",
      provinceName: "",
      city: "",
      zone: "",
      street: "",
      shequ: "",
    }
    this.getProvince()
    if (this.openData.title == "新增") {
    } else {
      this.dataInfos()
    }
    setTimeout(async () => {
      await this.$nextTick(() => this.loadmap())
    }, 200)
    this.getJoin()
  },
  methods: {
    // 获取组织机构
    getJoin() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
            if (this.openData.title == "新增") {
              this.changeFirst()
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    async changeFirst() {
      console.log(
        this.normalInfo,
        "机构信息 normalInfo.orgLevel",
        this.provinceList
      )
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
        console.log("城市", this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistricts(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.addCode == this.normalInfo.streetId) {
            this.formData.latitude = item.latitude
            this.formData.longitude = item.longitude
          }
        })
      }

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }
      this.formData.provinceId = this.normalInfo.provinceId
      this.formData.cityId = this.normalInfo.cityId
      this.formData.zoneId = this.normalInfo.areaId
      this.formData.streetId = this.normalInfo.streetId
      this.formData.shequId = this.normalInfo.communityId
      this.potintMap()
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    // 打点
    potintMap() {
      console.log(this.formData.longitude, this.formData.latitude, "地址")
      var map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 8,
        // zooms: [3, 20],
        expandZoomRange: true,
        center: [
          Number(this.formData.longitude),
          Number(this.formData.latitude),
        ],
      })
      var marker = new AMap.Marker({
        position: [
          Number(this.formData.longitude),
          Number(this.formData.latitude),
        ],
        map: map,
      })
      map.setFitView(marker)
    },
    // 地图打点
    getMap(input) {
      const self = this
      const autoOptions = {
        city: self.formData.zoneId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.longitude = e.poi.location.lng
        self.formData.latitude = e.poi.location.lat
        console.log(e.poi.location, "地址")
        self.potintMap()
      })
    },
    async streetChange(val) {
      this.formData.shequId = ""
      let communityList = await this.getCommityList(val)
      console.log(communityList, "社区列表")
      this.communityList = communityList
      this.joinAddress()
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 地图显示
    showMap() {
      this.isMaps = !this.isMaps
    },
    // 详情页信息
    dataInfos() {
      const self = this
      let params = {
        id: self.openData.id,
      }
      this.$http
        .request({
          url: "/ypt/admin/publicEducation/info/get",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            let jsonTemp = { ...res.content }
            console.log(JSON.stringify(jsonTemp), "数据")
            self.formData.id = jsonTemp.id
            self.formData.name = jsonTemp.name
            self.formData.photo = jsonTemp.photo
            self.formData.cover = jsonTemp.cover
            self.formData.remark = jsonTemp.remark
            self.formData.location = jsonTemp.location
            self.formData.address = jsonTemp.address

            self.formData.longitude = jsonTemp.longitude
            self.formData.latitude = jsonTemp.latitude

            self.formData.provinceId = String(jsonTemp.provinceId)
            self.formData.cityId = String(jsonTemp.cityId)
            self.formData.zoneId = String(jsonTemp.zoneId)
            self.formData.streetId = String(jsonTemp.streetId)
            self.formData.shequId = Number(jsonTemp.shequId)
            if (!self.formData.provinceId) return
            let city = await self.getDistrict(self.formData.provinceId)
            console.log(self.formData.recTime, "1111")
            self.cityList = city.districtList
            if (!self.formData.cityId) return
            let area = await self.getDistrict(self.formData.cityId)
            self.areaList = area.districtList
            if (!self.formData.zoneId) return
            let street = await self.getStreetList(self.formData.zoneId)
            self.streetList = street
            if (!self.formData.streetId) return
            let communityList = await self.getCommityList(
              self.formData.streetId
            )
            self.communityList = communityList
            if (self.formData.latitude && self.formData.longitude) {
              self.loadmap()
              setTimeout(() => {
                self.potintMap()
              }, 500)
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    //表格表单提交
    handleSubmit() {
      let self = this

      this.$refs.formData.validate((valid) => {
        if (valid) {
          if (this.openData.title == "新增" || this.openData.title == "编辑") {
            let url = ""

            if (!self.formData.provinceId) {
              self.$message.error("省级地址为必填项，请选择")
              return
            }
            if (!self.formData.cityId) {
              self.$message.error("市级地址为必填项，请选择")
              return
            }
            if (!self.formData.zoneId) {
              self.$message.error("区县级地址为必填项，请选择")
              return
            }
            if (!self.formData.streetId) {
              self.$message.error("街道地址为必填项，请选择")
              return
            }
            if (
              self.formData.shequId === "" ||
              self.formData.shequId === null ||
              self.formData.shequId === undefined
            ) {
              self.$message.error(
                "社区为必填项，请选择,如无对应社区，请地址管理配置"
              )
              return
            }
            if (!self.formData.address) {
              self.$message.error(
                "详细信息为必填项，请在地图的边界内点击选择或手动输入"
              )
              return
            }
            delete this.formData.recTime
            let data = { ...self.formData }
            data.type = 2
            url = "/ypt/admin/publicEducation/info/save"
            this.$http
              .request({
                url: url,
                method: "POST",
                data: {
                  ...data,
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.message)
                } else {
                  this.$message.error(res.message)
                }
                this.$emit("cancleService", true)
              })
          }
        }
      })
    },
    // 上传图片前的判断
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
        return isJPG
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!")
        return isLt2M
      }
    },
    //自定义图片上传
    handleAvatarSuccess(res, file, name) {
      this.$set(this.formData, "photo", res.content)
    },
    handleAvatarSuccess1(res, file, name) {
      this.$set(this.formData, "cover", res.content)
    },
    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let provinceName = this.$refs.selectShengChange.selectedLabel
        let city = this.$refs.selectShiChange.selectedLabel
        let zone = this.$refs.selectQuChange.selectedLabel
        let street = this.$refs.selectJiedaoChange.selectedLabel
        let shequ = this.$refs.selectShequChange.selectedLabel
        if (!address) {
          self.formData.address = provinceName + city + zone + street + shequ
          self.formData.provinceName = provinceName
          self.formData.city = city
          self.formData.zone = zone
          self.formData.street = street
          self.formData.shequ = shequ
        }
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        let geocoder = new AMap.Geocoder({ city: "" })
        self.marker = new AMap.Marker()
        geocoder.getLocation(this.formData.address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            self.formData.longitude = lnglat.lng
            self.formData.latitude = lnglat.lat
            self.marker.setPosition(lnglat)
            self.myMap.add(self.marker)
            self.myMap.setFitView(self.marker)
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (error) {
                console.log("移除地图编辑出错了")
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on("click", function (e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(lnglat, function (status, result) {
                      if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress
                        self.formData.address = address
                        self.formData.longitude = lnglat.lng
                        self.formData.latitude = lnglat.lat
                      } else {
                        console.error("根据经纬度查询地址失败")
                      }
                    })
                  })
                  self.myMap.add(self.polygons)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.longitude && params.latitude) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([params.longitude, params.latitude])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.cityId = ""
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      // val = val.replace(/.$/, "");
      let street = await this.getStreetList(val)
      this.streetList = street
      this.joinAddress()
    },

    //加载地图
    loadmap() {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("container", {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },
    // 关闭人员信息
    dialogVisibleClone() {
      // this.openData.state=false;
      this.$emit("cancleService", false)
    },
  },
}
</script>
<style lang="less" scoped>
.avatar {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  img {
    width: 200px;
    height: 200px;
    line-height: 200px;
    display: block;
  }
}
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 200px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
}
.dialog-footer-btn {
  text-align: center;
}
</style>
